"use client";
import { IMAGES, SUBSTAGE, WEB_COLORS } from "@/lib/constants";
import { setModalAttributes } from "@/lib/redux/slice/ModalSlice";
import { useTheme } from "@emotion/react";
import { Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";
import ButtonComponent from "../Button";
import ModalComponent from "../Modal";
// import { useRouter } from "@/i18n/routing";

const FaceMismatchModal = () => {
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const router = useRouter();
  const path = usePathname();

  const { open, message, type } = useSelector((state) => state?.modal);

  const handleButtonClick = () => {
    if (type === SUBSTAGE?.DIGI_KYC_FAIL_FACEMATCH) {
      dispatch(setModalAttributes({ isRouting: true, targetRoute: "/" }));
      router.replace("/");
    }
    dispatch(setModalAttributes({ open: false, message: "", type: "" }));
  };
  return (
    <ModalComponent
      maxWidth={isBelowMd ? "xs" : "md"}
      open={open}
      closeButtonRequired={false}
    >
      <Grid
        container
        spacing={3}
        padding={2}
        pb={0}
        // flexDirection={{ md: "row", xs: "column" }}
        alignItems="center"
        justifyContent={"space-between"}
        // gap={1}
      >
        <Grid
          item
          md={6}
          xs={12}
          sx={{
            backgroundColor: { md: "#E9FFE6", xs: "none" },
            height: { md: "436px" },
            width: { md: "463px" },
          }}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Image
            src={IMAGES.faceMismatch}
            height={isBelowMd ? "120" : "191px"}
            width={isBelowMd ? "200" : "216px"}
            alt="Face Mismatch Found"
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <Typography
            textAlign={{ xs: "center", md: "left" }}
            fontWeight={{ md: 700, xs: 500 }}
            fontSize={{ md: "24px", xs: "16px" }}
            color={WEB_COLORS.darkTeal}
            mb={1}
          >
            Face Mismatch Found
          </Typography>
          <Typography
            textAlign={{ xs: "center", md: "left" }}
            fontWeight={400}
            fontSize={{ md: "14px", xs: "12px" }}
            color={WEB_COLORS.textFadeColor}
            mb={2}
          >
            {message}
          </Typography>

          <Stack width={"100%"} flexGrow={1}>
            <ButtonComponent onClick={handleButtonClick}>
              {type === SUBSTAGE?.DIGI_KYC_FAIL_FACEMATCH &&
              path &&
              path !== "/en"
                ? "Go To Homepage"
                : type === "FACE_MISMATCH_ERROR"
                ? "Retry"
                : "Notify Me"}
            </ButtonComponent>
          </Stack>
        </Grid>
      </Grid>
    </ModalComponent>
  );
};

export default FaceMismatchModal;
